import { ContactUs, CopyrightFooter, DataGrid, FindAFoundation, MaterialInput } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Col, Panel, Row, Well } from 'react-bootstrap'
import { Link } from 'react-router-dom';

class ComingSoon extends Container<{}, {}> {

  mapAppStateToContainerState(appState: IAppState): {} {
    return {}
  }

  render() {
    return (
      <section>
        <section className="margin-y-lg">
          <Well bsStyle="info" style={{ marginBottom: 0 }}>
            <div className="container" style={{ overflowX: 'hidden' }}>
              <h2 className="animated fadeIn">
                <div>Coming Soon</div>
                <small>Please contact us below for more information</small>
              </h2>
            </div>
          </Well>
        </section>

        <footer>
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    )
  }
}

export {
  ComingSoon
}



// WEBPACK FOOTER //
// ./src/app/containers/ComingSoon/index.tsx